import React, { ReactNode, useState } from 'react'
import { ReactJSXElement } from '@emotion/react/types/jsx-namespace'
import { Box, Card, CardContent, CardProps } from '@mui/material'
import circlesOrbitColorPalette from 'common/ui/circlesColorTheme'

interface Props extends CardProps {
  header?: string
  icon: ReactJSXElement
  backContent?: ReactNode
  warning: boolean
}

export default function Flipcard(props: Props) {
  const { children, icon, backContent, warning } = props
  const [isFlipped, setIsFlipped] = useState(false)

  const handleFlip = () => {
    setIsFlipped(!isFlipped)
  }

  return (
    <>
      <Card
        onClick={handleFlip}
        sx={{
          cursor: 'pointer',
          backgroundColor: '#FFFFFF',
          borderRadius: '34px',
          overflow: 'visible',
          p: '24px',
          height: '220px',
          zIndex: 1,
          position: 'relative',
          width: '230px',
          boxShadow: 'none',
          transition: 'transform 0.6s',
          transformStyle: 'preserve-3d',
          transform: isFlipped ? 'rotateY(180deg)' : 'rotateY(0deg)'
        }}
      >
        <Box
          sx={{
            width: '80px',
            height: '80px',
            display: 'flex',
            justifyContent: 'center',
            alignItems: 'center',
            background: warning
              ? circlesOrbitColorPalette.error.main
              : circlesOrbitColorPalette.success.main,
            position: 'absolute',
            ml: '10rem',
            borderRadius: '50%',
            mt: '-70px',
            zIndex: 3
          }}
        >
          {icon}
        </Box>
        {/* Front Side */}
        <CardContent
          sx={{
            zIndex: 2,
            p: '24px',
            backgroundColor: '#ffffff',
            backfaceVisibility: 'hidden',
            position: 'absolute',
            top: 0,
            left: 0
          }}
        >
          {children}
        </CardContent>
        {/* Back Side */}
        <Box
          sx={{
            position: 'absolute',
            top: 0,
            left: 0,
            width: '100%',
            height: '100%',
            transform: 'rotateY(180deg)',
            backfaceVisibility: 'hidden'
          }}
        >
          <CardContent
            sx={{
              zIndex: 2,
              p: '24px',
              backgroundColor: '#ffffff',
              backfaceVisibility: 'hidden',
              position: 'absolute',
              top: 0,
              left: 0
            }}
          >
            {backContent}
          </CardContent>
        </Box>{' '}
      </Card>
    </>
  )
}
